/**
 * src/components/ui/GlassInput.tsx
 * Frosted text input and textarea with focus glow
 */

import React from 'react';

interface GlassInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}

export const GlassInput: React.FC<GlassInputProps> = ({
  label,
  error,
  icon,
  className = '',
  id,
  ...props
}) => {
  const inputId = id || (label ? label.toLowerCase().replace(/\s+/g, '-') : undefined);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
      {label && (
        <label
          htmlFor={inputId}
          style={{
            fontSize: '0.84rem',
            fontWeight: 600,
            color: 'var(--text-secondary)'
          }}
        >
          {label}
        </label>
      )}

      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        {icon && (
          <span style={{
            position: 'absolute',
            left: '14px',
            color: 'var(--text-tertiary)',
            display: 'flex',
            alignItems: 'center',
            pointerEvents: 'none'
          }}>
            {icon}
          </span>
        )}

        <input
          id={inputId}
          className={`glass-input ${className}`}
          style={icon ? { paddingLeft: '40px' } : undefined}
          {...props}
        />
      </div>

      {error && (
        <span style={{ fontSize: '0.8rem', color: 'var(--crimson-light)', marginTop: '2px' }}>
          {error}
        </span>
      )}
    </div>
  );
};
